import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";
import { dbh_suchergebnis } from "../Controls/dbh_suchergebnis";
import { dbh_custom_validation } from "../ClientValidation/dbh_custom_validation";

if (dbh_helper.getUrlArea() == "adressen") {
    $('#dbh_AdressenDetails').ready(function () {
        if ($("#dbh_AdressenDetails") && $("#dbh_AdressenDetails").length > 0) {
            let id = dbh_helper.getUrlParameter("id");

            if (id && id != "") {

                BindAdressFunctions(id);
                dbh_helper.OnSetDefaultFormValues = () => {
                    BindAdressFunctions(id);
                };

                $("#showKoordinatorenPunktePopup").on("click", function () {
                    //@ts-ignore
                    window.showPopup('KoordinatorenpunkteViewComponentPopup')
                });

                $("#btnToggleFavAction").on("click", function () {
                    toggleFav($("#btnToggleFavAction"), id);
                })

                const adressGroup = $("#FK_Adressgruppen").val();
                ShowHideBankdatenContent();
            }
            else {
                if ($('#btnToggleEditAndViewMode').length > 0) {
                    $('#btnToggleEditAndViewMode').get(0).click();
                }
            }

            $("#FK_Adressgruppen").on("change", function () {
                const adressGroup = $(this).val();

                GetBankDataForm(adressGroup, id, true);
                GetWohnungView(adressGroup, id, true);
                GetShowAusbildung(adressGroup);

                let groupId: string = $(this).val() as string;

                new dbh_ajax().sendGetRequest({
                    actionName: "GetAdressGruppen",
                    controllerName: "Adressen",
                    parameter: [["adressId", id], ["groupId", groupId], ["formFieldsEnabled", "true"]],
                    callbackSuccess: (ajaxResult: any) => {
                        $("#AdressGruppenForm").html(ajaxResult.responseText);

                        CheckNameUndVornameAufDuplikat();
                    },
                    callbackError: (ajaxResult: object) => {
                        console.log(ajaxResult);
                    }
                });
            });

            $("#addPartnerBtn").on("click", function () {
                new dbh_ajax().sendGetRequest({
                    actionName: "GetAddPartnerPopup",
                    controllerName: "Adressen",
                    parameter: [["id", id]],
                    callbackSuccess: (ajaxResult: any) => {
                        $(`#addPartner-placeholder`).html(ajaxResult.responseText);
                        $('#AddPartnerViewComponentPopup').fadeIn("fast");
                    },
                    callbackError: (ajaxResult: object) => {
                    }
                });
            });

            $("#addDokument").on("click", function () {
                new dbh_ajax().sendGetRequest({
                    actionName: "AddDokumentPopupView",
                    controllerName: "Adressen",
                    parameter: [["id", id]],
                    callbackSuccess: (ajaxResult: any) => {
                        $('#addDokument-placeholder').html(ajaxResult.responseText);
                        $('#AddDokumentViewComponentPopup').fadeIn("fast");
                    },
                    callbackError: (ajaxResult: object) => {

                    }
                });
            });

            $('.btnDokumentLoeschen').on('click', (e) => {

                new dbh_ajax().sendGetRequest({
                    actionName: "GetDokumentEntfernenPopupView",
                    controllerName: "Adressen",
                    parameter: [["id", $(e.target).attr('data-id')]],
                    callbackSuccess: (ajaxResult: any) => {
                        $('#deleteDokument-placeholder').html(ajaxResult.responseText);
                        (window as any).showPopup("GetDokumentEntfernenPopupView");

                        $("#deleteDokument-placeholder").ready(function () {
                            $('#btnPrimaryAdressenDokumentEntfernen').on('click', (e) => {
                                var form = dbh_helper.findNearestForm(e.target);

                                new dbh_ajax().sendPostRequest({
                                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                    actionName: "DeleteDokument",
                                    controllerName: "Adressen",
                                    parameter: dbh_helper.getParameterStringForForm(form),
                                    callbackSuccess: (ajaxResult: any) => {
                                        window.location.reload();
                                    },
                                    callbackError: (ajaxResult: any) => {

                                        $('#dbhErrorDokumentEntfernen').html(ajaxResult.responseJSON.message).show();
                                    }
                                });

                                e.stopPropagation();
                            });
                        });
                    },
                    callbackError: (ajaxResult: object) => {
                    }
                });

                e.stopPropagation();
            });

            $("#deleteCurAdresse").on("click", function () {
                sendGetRequest("AdresseLoeschen", "adressen", [["id", id]], "#delete-placeholder", function () {
                    $("#DeleteConfirmViewComponentPopup").show();
                })
            })

            $("#handleZugangBtn").on("click", function () {
                sendGetRequest("HandleZugang", "adressen", [["id", id]], "#zugang-placeholder", function () {
                    $("#ZugangConfirmViewComponentPopup").show();
                })
            })

            $("#Adressschutz").on("change", function () {
                if ($(this).prop("checked") === true) {
                    $(".adressSchutzIcon").addClass("active");
                } else {
                    $(".adressSchutzIcon").removeClass("active");
                }
            });

            $("#FK_Anreden").on("change", function () {
                let id = dbh_helper.getUrlParameter("id");
                let anredeId: string = $(this).val() as string;

                new dbh_ajax().sendGetRequest({
                    actionName: "GetAnrede",
                    controllerName: "Adressen",
                    parameter: [["id", id], ["anredeId", anredeId]],
                    callbackSuccess: (ajaxResult: any) => {
                        $("#AnredeOptionen").html(ajaxResult.responseText);
                    },
                    callbackError: (ajaxResult: object) => {
                        console.log(ajaxResult);
                    }
                });
            });
        }

        let dbhCustomValidation = new dbh_custom_validation();
        dbhCustomValidation.initClientValidators();
    });
}

const redirectToSelf = () => {
    const id = dbh_helper.getUrlParameter("id");
    location.href = `/Adressen/Details?id=${id}`;
}

const GetBankDataForm = (adressGroup, id, isEnabled) => {

    sendGetRequest("GetBankdatenForm", "Adressen", [["id", id], ["adressGroup", adressGroup], ["isEnabled", isEnabled]], `#bankdatenFormContent`, function () {
        ShowHideBankdatenContent();
    });
}

const ShowHideBankdatenContent = () => {
    if ($("#bankdatenFormContent").length > 0 && $("#bankdatenFormContent").html().trim().length > 0) {
        $("#bankdatenFormContainer").addClass("show");
    } else {
        $("#bankdatenFormContainer").removeClass("show");
    }
}

const GetShowAusbildung = (adressGroup) => {
    return new dbh_ajax().sendGetRequest({
        actionName: "ShowAusbildung", controllerName: "Adressen",
        parameter: [["adressGroup", adressGroup]], callbackSuccess: (ajaxResult: any) => {
            if (ajaxResult.responseText.toString().toLowerCase() === "true") {
                $("#ausbildungContainer").addClass("show");
            } else {
                $("#ausbildungContainer").removeClass("show");
            }
        },
        callbackError: (ajaxResult: object) => {
            $("#ausbildungContainer").removeClass("show");
        }
    });
}

const GetWohnungView = (adressGroup, adressId, isEnabled) => {
    sendGetRequest("GetWohnungForm", "Adressen", [["id", adressId], ["adressGroup", adressGroup], ["isEnabled", isEnabled]], `#wohnungContainer`, function () {
        if ($("#wohnungContainer").length > 0 && $("#wohnungContainer").html().trim().length > 0) {
            $("#wohnungContainer").addClass("show");
        } else {
            $("#wohnungContainer").removeClass("show");
        }
    });
}

const sendGetRequest = (actionName, controllerName, parameter, htmlId, doOnSuccess = null) => {
    var noErrors: Boolean = true;
    return new dbh_ajax().sendGetRequest({
        actionName: actionName,
        controllerName: controllerName,
        parameter: parameter,
        callbackSuccess: (ajaxResult: any) => {
            if (noErrors) {
                $(`${htmlId}`).html(ajaxResult.responseText);
                if (doOnSuccess) {
                    doOnSuccess();
                }
            }
            noErrors = true;
        },
        callbackError: (ajaxResult: object) => {
            noErrors = (ajaxResult as any).status == 200;
            console.log(ajaxResult);
        }
    });
}


const toggleFav = ($element, addressId) => {
    sendGetRequest("ToggleFavorite", "Adressen", [["adressId", addressId]], null);

    $element.toggleClass("active");
    if ($element.html().indexOf("Favorisieren") >= 0) {
        $element.html($element.html().replace("Favorisieren", "Favorisiert"));
    } else {
        $element.html($element.html().replace("Favorisiert", "Favorisieren"));
    }
}

const BindAdressFunctions = (adressId) => {
    /*Partner*/
    initAddPartner(adressId);
    initPartnerUebernehmen(adressId);
    initDeletePartner(adressId);

    /*KoordinatorenPunkte*/
    initAddKoordinatorenpunkte();
    initCancelAndSave(adressId);
    initEditKoordinatorenpunkte(adressId);
    initDeleteKoordinatorenpunkte(adressId);
}

const initAddPartner = (adressId) => {
    $("#addPartnerFonfirmBtn").off("click");
    $("#addPartnerFonfirmBtn").on("click", function () {
        const partnerId = $("#FK_Partner")?.val();

        if (partnerId) {

            const model = [];
            model.push(["pk_Adresse", adressId]);
            model.push(["fK_Partner", partnerId]);

            sendGetRequest("AddPartner", "Adressen", model, "", function () {
                //@ts-ignore
                window.hidePopup('AddPartnerViewComponentPopup');
                new dbh_suchergebnis().defaultReloadSearchResult($('#PartnerTabelleMitSuche .dbhSuchergebnis').first().get(0));
            });
        }
    });

    $("#addPartnerCancelBtn").off("click");
    $("#addPartnerCancelBtn").on("click", function () {
        //@ts-ignore
        window.hidePopup('AddPartnerViewComponentPopup');
    });
}

const initPartnerUebernehmen = (adressId) => {
    $("#PartnerTabelleMitSuche .dbhCustomTableBtn").off("click");
    $("#PartnerTabelleMitSuche .dbhCustomTableBtn").on("click", function () {
        const $btn = $(this);
        const partnerId = $btn.data().id;

        sendGetRequest("GetAdresseUebernehmenPopup", "Adressen", [["id", adressId], ["partnerId", partnerId]], "#adrUebernehmen-placeholder", function () {
            $(`#AdresseUebernehmenViewComponentPopup`).fadeIn("fast");
        });
    });
}

const initDeletePartner = (adressId) => {
    $('#PartnerTabelleMitSuche .tableDeleteElement').off("click");
    $('#PartnerTabelleMitSuche .tableDeleteElement').on("click", function () {
        const partnerId = $(this).closest("[data-rowid]").data("rowid");

        const showConfirm = () => {
            //@ts-ignore
            window.showPopup('DeletePartnerConfirmViewComponentPopup');
        }

        sendGetRequest("DeletePartnerZuweisungConfirm", "Adressen", [["id", adressId], ["partnerId", partnerId]], `#deletePartner-placeholder`, showConfirm);
    });

    $("#deletePartnerZuweisungConfirm").off("click");
    $("#deletePartnerZuweisungConfirm").on("click", function () {
        const partnerId = $(this).data("partnerid");
        const popupid = `popupContainer_${adressId}`;

        const hideAndRender = () => {
            //@ts-ignore
            window.hidePopup('DeletePartnerConfirmViewComponentPopup');
            new dbh_suchergebnis().defaultReloadSearchResult($('#PartnerTabelleMitSuche .dbhSuchergebnis').first().get(0));
        }
        sendGetRequest("DeletePartnerZuweisung", "Adressen", [["id", adressId], ["partnerId", partnerId]], '', hideAndRender);
    });

    $("#cancelPartnerZuweisungConfirm").off("click");
    $("#cancelPartnerZuweisungConfirm").on("click", function () {
        //@ts-ignore
        window.hidePopup('DeletePartnerConfirmViewComponentPopup');
    });
}

const initAddKoordinatorenpunkte = () => {
    const $addElement = $("#addKoordinatorenPunkteBtn");
    if ($addElement.length === 0) { return; }
    $("#addKoordinatorenPunkteBtn").off("click");
    $("#addKoordinatorenPunkteBtn").on("click", function () {
        const id = $addElement.data("id");
        const htmlIdWithHashtag = `#${$addElement.data("htmlid")}`;
        sendGetRequest("GetKommunikationspunkteForm", "Adressen", [["id", id], ["viewMode", "new"]], htmlIdWithHashtag);
    })
}

const initCancelAndSave = (adressId) => {
    $("#cancelKoordinatorenPunktBtn").off("click");
    $("#cancelKoordinatorenPunktBtn").on("click", function () {
        sendGetRequest("CancelKoordinatorenpunkte", "Adressen", [["adressId", adressId]], `#popupContainer_${adressId}`);
    });

    $("#saveKoordinatorenPunktBtn").off("click");
    $("#saveKoordinatorenPunktBtn").on("click", function () {

        const pkKoordinatorenpunkt = $("#PK_Koordinatorenpunkte").val().toString();
        const isNew = pkKoordinatorenpunkt && pkKoordinatorenpunkt.length > 0;
        let parameterName = isNew ? "pkKoordinatorenpunkte" : "adressKey";
        let parameterValue = isNew ? `${pkKoordinatorenpunkt}` : `${adressId}`;

        const model = [];
        model.push([parameterName, parameterValue]);
        //@ts-ignore
        model.push(["von", document.getElementById("Von").value]);
        //@ts-ignore
        model.push(["bis", document.getElementById("Bis").value]);
        //@ts-ignore
        model.push(["punkte", document.getElementById("Punkte").value]);

        sendGetRequest(isNew ? "EditKoordinatorenpunkte" : "AddKoordinatorenpunkte", "Adressen", model, `#popupContainer_${adressId}`);
    });
}

const initEditKoordinatorenpunkte = (adressId) => {
    $('.KoordinatorenPunkteSuchenModel *[data-rowid]').off('click');
    initTableCellClicks("Adressen", "GetKommunikationspunkteForm", "KoordinatorenPunkteSuchenModel", adressId);
}

const initDeleteKoordinatorenpunkte = (adressId) => {
    $('.KoordinatorenPunkteSuchenModel .tableDeleteElement').off("click");
    $('.KoordinatorenPunkteSuchenModel .tableDeleteElement').on("click", function () {
        const koordinatorenPunktId = $(this).closest("[data-rowid]").data("rowid");
        const popupid = `popupContainer_${adressId}`;

        sendGetRequest("DeleteKoordinatorenpunkteConfirm", "Adressen", [["koordinatorenPunkteId", koordinatorenPunktId], ["adressId", adressId]], `#${popupid}`);
    });

    $("#deletePunkteConfirm").off("click");
    $("#deletePunkteConfirm").on("click", function () {
        const koordinatorenPunktId = $(this).data("punkteid");
        const popupid = `popupContainer_${adressId}`;

        sendGetRequest("DeleteKoordinatorenpunkte", "Adressen", [["koordinatorenPunkteId", koordinatorenPunktId], ["adressId", adressId]], `#${popupid}`);
    });

    $("#cancelPunkteConfirm").off("click");
    $("#cancelPunkteConfirm").on("click", function () {
        sendGetRequest("CancelKoordinatorenpunkte", "Adressen", [["adressId", adressId]], `#popupContainer_${adressId}`);
    });
}

const initTableCellClicks = (controller: string, action: string, tableContainer: string, adressId: string) => {
    const clickElements = dbh_helper.InitTableClickedElements(tableContainer);

    for (let i = 0; i < clickElements.length; i++) {
        $(clickElements[i][0]).on("click", function (e) {
            const popupid = `popupContainer_${adressId}`;

            sendGetRequest(action, controller, [["id", clickElements[i][1]], ["viewMode", "edit"]], `#${popupid}`);
        });
    }
}

const CheckNameUndVornameAufDuplikat = () => {
    $('#Vorname, #Name').on("change", function (e) {
        let Name = $('#Name');
        let Vorname = $('#Vorname');

        if (Name != null && Name != undefined &&
            Vorname != null && Vorname != undefined) {

            var form = dbh_helper.findNearestForm(e.target);

            new dbh_ajax().sendPostRequest({
                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                actionName: "CheckAdresseAufDuplikat",
                controllerName: "Adressen",
                parameter: dbh_helper.getParameterStringForForm(form),
                callbackSuccess: (ajaxResult: any) => {
                    console.log(ajaxResult);
                    if (ajaxResult != null) {
                        $('#popup-placeholder').html(ajaxResult);
                        $('#AdresspruefungViewComponentPopup').fadeIn("fast");
                        $('#cancelAdressPruefungBtn').on("click", function () {
                            $('#popup-placeholder').html(ajaxResult);
                            $('#AdresspruefungViewComponentPopup').fadeOut("fast");
                        });
                    }
                },
                callbackError: (ajaxResult: any) => {

                }
            });
        }
    });
}